/**
 * NetworkThemeLink entity class
 */

/**
 * NetworkThemeLinkFactory
 * returns NetworkThemeLink entity class
 *
 * @class NetworkThemeLinkFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.NetworkThemeLink} class
 *
 * @ngdoc factory
 * @name mwApp.factory:NetworkThemeLinkFactory
 */
/* @ngInject */
export default function NetworkThemeLinkFactory (Entity, Type) {
  /* === NetworkThemeLink class === */

  /**
   * NetworkThemeLink model
   *
   * @class NetworkThemeLink
   * @classdesc NetworkThemeLink model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing NetworkThemeLink entity fields
   * @return {models.NetworkThemeLink} NetworkThemeLink entity
   */
  function NetworkThemeLink () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  NetworkThemeLink.prototype = Object.create(Entity.prototype)
  NetworkThemeLink.prototype.constructor = NetworkThemeLink

  /* === NetworkThemeLink instance methods & fields === */

  Object.assign(NetworkThemeLink.prototype, {

    /**
     * instance fields
     *
     * @memberof models.NetworkThemeLink#
     * @type {Object}
     */
    _fields: {
      id: Number,
      subTheme: 'SubTheme',
      videoType: Type(String('No_Video')), // Background_Video,Video_Box,No_Video
      network: 'Network',
      theme: 'Theme'
    }

  })

  /* === NetworkThemeLink static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(NetworkThemeLink, Entity)
  NetworkThemeLink._name = 'NetworkThemeLink'
  NetworkThemeLink.init()

  return NetworkThemeLink
}
